import React from 'react'
import { Box, Container } from "@mui/material";
import { AMITASOFT_BRAND } from './theme/amitasoftBrand';
import { AMITASOFT_TYPO } from './theme/amitasoftTypography';
import BannerMain from './components/banner/new-banner';
import MainComponentFinal from './components/pagination/MainComponentFinal';
import BlogSeo from './components/BlogSeo';

export default function Home() {
    return (
        <Box sx={{ backgroundColor: AMITASOFT_BRAND.pageBg, minHeight: '100vh' }}>
            <BlogSeo
                title="AmitaSoft Blog | Document Intelligence for Lending and Tax"
                description="Articles on document workflows, verification, compliance, and AI for lending, tax, and other regulated teams — from the AmitaSoft team."
                canonicalPath="/blog/"
                image="https://amitasoft.com/images/social/amitasoft-default-1200x630.png"
                type="website"
            />
            <BannerMain />
            <Container
                maxWidth="lg"
                sx={{
                    px: { xs: 2, sm: 3, md: AMITASOFT_TYPO.pagePadding },
                    pb: { xs: 6, md: 8 },
                }}
            >
                <Box marginY={2}>
                    <MainComponentFinal />
                </Box>
            </Container>
        </Box>
    )
}
